import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail } from "lucide-react";
import { BRAND } from "@/data/brand";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-navy text-cream mt-20">
      <div className="jm-container py-16 grid gap-10 md:grid-cols-5">
        <div className="md:col-span-2">
          <span className="font-display text-3xl">JOHNNY<span className="text-gold">MART</span></span>
          <p className="mt-3 max-w-md text-cream/80 leading-relaxed">{BRAND.about}</p>
          <p className="mt-4 flex items-center gap-2 text-cream/70 text-sm">
            <MapPin className="w-4 h-4 text-gold" /> {BRAND.location}
          </p>
        </div>

        <div>
          <h3 className="font-display text-lg text-gold uppercase mb-4">Shop</h3>
          <ul className="space-y-2 text-cream/80 text-sm">
            <li><Link to="/shop" className="hover:text-gold transition-colors">Shop JohnnyMart</Link></li>
            <li><Link to="/gateway" className="hover:text-gold transition-colors">Gorilla Gateway</Link></li>
            <li><Link to="/other-partners" className="hover:text-gold transition-colors">Other Partners</Link></li>
            <li><Link to="/reviews" className="hover:text-gold transition-colors">Customer Reviews</Link></li>
            <li><Link to="/about" className="hover:text-gold transition-colors">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-gold transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="font-display text-lg text-gold uppercase mb-4">Help</h3>
          <ul className="space-y-2 text-cream/80 text-sm">
            <li><Link to="/policies/faq" className="hover:text-gold transition-colors">FAQ</Link></li>
            <li><Link to="/policies/shipping" className="hover:text-gold transition-colors">Shipping</Link></li>
            <li><Link to="/policies/pickup" className="hover:text-gold transition-colors">Local Pickup</Link></li>
            <li><Link to="/policies/condition" className="hover:text-gold transition-colors">Item Condition</Link></li>
            <li><Link to="/policies/accessibility" className="hover:text-gold transition-colors">Accessibility</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="font-display text-lg text-gold uppercase mb-4">Policies</h3>
          <ul className="space-y-2 text-cream/80 text-sm">
            <li><Link to="/policies/returns" className="hover:text-gold transition-colors">Returns &amp; Refunds</Link></li>
            <li><Link to="/policies/authenticity" className="hover:text-gold transition-colors">Authenticity &amp; Brand</Link></li>
            <li><Link to="/policies/privacy" className="hover:text-gold transition-colors">Privacy</Link></li>
            <li><Link to="/policies/terms" className="hover:text-gold transition-colors">Terms</Link></li>
          </ul>
          <div className="flex gap-3 mt-5">
            <a href={`mailto:${BRAND.email}`} aria-label="Email JohnnyMart" className="hover:text-gold transition-colors"><Mail className="w-5 h-5" /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-cream/15">
        <div className="jm-container py-4">
          <p data-testid="footer-affiliate-disclosure" className="text-[11px] text-cream/55 leading-relaxed max-w-3xl">
            <strong className="text-cream/70">Affiliate disclosure:</strong> "Johnny's Must-Buys" are products we recommend on third-party
            retailers. JohnnyMart may earn a commission from qualifying purchases made through those links, at no
            extra cost to you. Those items are sold by the retailer, not by JohnnyMart.
          </p>
        </div>
      </div>
      <div className="border-t border-cream/15">
        <div className="jm-container py-5 flex flex-col sm:flex-row gap-2 items-center justify-between text-xs text-cream/60">
          <span>© {new Date().getFullYear()} JohnnyMart. All rights reserved.</span>
          <span className="text-gold">Great finds. Cool stuff. Good vibes.</span>
        </div>
      </div>
    </footer>
  );
};
